import React from 'react'
import styles from './style.module.scss'

const Page : React.FC = ({children}) => {
    return (
        <div className={styles.Page}>
            {children}
        </div>
    )
}

export default Page